import { render, staticRenderFns } from "./GrillaCard.vue?vue&type=template&id=b03067dc&scoped=true&"
import script from "./GrillaCard.vue?vue&type=script&lang=js&"
export * from "./GrillaCard.vue?vue&type=script&lang=js&"
import style0 from "./GrillaCard.vue?vue&type=style&index=0&id=b03067dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03067dc",
  null
  
)

export default component.exports